<template>
  <div>
    <router-view  id="lock" />
    <div id="rotation-warning">
      	<i class="material-icons">screen_rotation</i>
	      <p>Por favor voltea tu telefono</p>
    </div>

</div>
</template>


<script>
  //import axios from 'axios'
  
  export default {
    name: 'skeleton',
  data() {
    return {
      installBtn: "none",
      installer: undefined
    };
  },
  created() {

  },

    components: {
    },
    props: {
    },
    methods:{
    },
    watch:{
    },
    mounted() {

    }
  }

</script>

<style lang="scss">

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}


body {
  overscroll-behavior: none 
}
</style>

